import React from 'react';
import { WelcomeImage, WelcomeContent, SidebarCard } from './welcome';
import { useLanguage } from '../contexts/LanguageContext';
import { LAYOUT } from '../styles/constants';
import useMediaQuery from '../hooks/useMediaQuery';

const WelcomeSection = () => {
  const { t } = useLanguage();
  const isDesktop = useMediaQuery('(min-width: 1024px)');

  const notices = [
    'Important Court Announcement',
    'New Filing Guidelines',
    'Court Schedule Update'
  ];

  const downloads = [
    'Court Forms',
    'Filing Guidelines',
    'Court Calendar'
  ];

  return (
    <div className="max-w-[1762px] mx-auto px-4 py-8">
      <div className="flex flex-col lg:flex-row gap-8">
        {/* Welcome Image and Content Container */}
        <div className="flex flex-col lg:flex-row flex-grow">
          <div className="flex flex-col lg:flex-row">
            <WelcomeImage
              imageUrl="https://images.unsplash.com/photo-1589994965851-a8f479c573a9?w=286&h=448&fit=crop"
              name="Hon. Dr. John Doe"
              position="Chief Justice"
            />
            <div className="lg:-ml-px"> {/* Negative margin to attach to image */}
              <WelcomeContent />
            </div>
          </div>
        </div>

        {/* Sidebar Cards Container */}
        <div className={`flex ${isDesktop ? 'flex-row' : 'flex-col'} gap-8`}>
          <SidebarCard
            title={t('notice.title')}
            items={notices}
            type="notice"
          />
          <SidebarCard
            title={t('downloads.title')}
            items={downloads}
            type="downloads"
          />
        </div>
      </div>
    </div>
  );
};

export default WelcomeSection;